import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RatingComponent } from "./rating.component";
import { ReviewForEdit, LocationReview } from '../../../../globalTypes/review.types';

@Component({
  selector: 'msh-review-tile',
  standalone: true,
  imports: [RatingComponent],
  template: `
    <div [class]="'border rounded cursor-pointer ' + (small ? ' p-2 text-sm max-w-[200px]' : ' p-4')">
      <div [class]="'font-semibold ' + (small ? ' overflow-hidden truncate' : '')">{{review.title}}</div>
      <msh-rating class="my-2 block" [(rating)]="review.rating" [readonly]="true" [small]="small"></msh-rating>
      @if(small){
        <div class="text-xs text-copy/50">{{imageUrls.length}} images</div>
      } @else {
        <div class="text-sm text-copy/70">{{review.body}}</div>
        @if(imageUrls.length > 0) {
          <div class="mt-2 flex gap-2 flex-wrap ">
            @for (url of imageUrls; track url) {
              <img [src]="url" class="w-16 h-16 object-cover rounded" />
            }
          </div>
        }
      }      
    </div>
  `,
})
export class ReviewTileComponent implements OnChanges {

  @Input() review!: ReviewForEdit | LocationReview;
  @Input() small: boolean = false;
  imageUrls: string[] = [];

  constructor() {}
  ngOnChanges(changes: SimpleChanges) {
    if(changes['review'] && changes['review'].currentValue){
      this.review = changes['review'].currentValue;
      this.imageUrls = this.review.reviewImages_on_review
        .sort((a, b) => a.sortOrder - b.sortOrder)
        .map(img => img.image.url) || [];
    }
  }
}